import React from 'react';
import { Icon, Button } from 'components';
import { Box, FlexList, H1, H2, H3, RowBox, Text } from 'styles';
import * as S from './HeaderStyle';

// 같은 페이지 안의 섹션은 스크롤, 콘텐츠 페이지(/library, /weekly)는 링크로 이동
const MENUS = [
  { label: '서비스', section: 'about' },
  { label: '프로세스', section: 'process' },
  { label: '요금제', section: 'price' },
  { label: 'FAQ', section: 'faq' },
  { label: '인사이트', href: '/library/' },
  { label: '카드뉴스', href: '/cardnews/' },
  { label: 'Weekly', href: '/weekly/' },
];

export function Header({ sectionRefs }) {
  const scrollToSection = (section) => {
    sectionRefs.current[section].scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <S.Header>
      <Box $margin="auto" $padding="20px 40px" $mPadding="0 20px">
        <H1 $display="none">N-Survey</H1>
        <RowBox $gap={160} $mGap={8} $justifyContent="space-between" $mFlexDirection="column" $mAlignItems="center">
          <Icon name="LogoText" $mSvgHeight={31} $mMargin="9px 0" $mTextAlign="center" />
          <S.Nav>
            <H2 $display="none">네비게이션 메뉴</H2>
            <FlexList $gap={16} $mGap="0px" $mFlexWrap="nowrap">
              {MENUS.map((m) =>
                m.href ? (
                  <S.HeaderListItem key={m.label} $padding="10px 16px" $mPadding="8px 6px">
                    <S.HeaderLink href={m.href}>
                      <H3 $type="sb16" $mType="sb13" $mWhiteSpace="nowrap">{m.label}</H3>
                    </S.HeaderLink>
                  </S.HeaderListItem>
                ) : (
                  <S.HeaderListItem key={m.label} $padding="10px 16px" $mPadding="8px 6px" onClick={() => scrollToSection(m.section)}>
                    <H3 $type="sb16" $mType="sb13" $mWhiteSpace="nowrap">{m.label}</H3>
                  </S.HeaderListItem>
                )
              )}
            </FlexList>
          </S.Nav>
          <Button $type="modal" $tDisplay="none" onClick={() => sectionRefs.current['request'].scrollIntoView({ behavior: 'smooth' })}>
            <Text $type="b14">문의 / 의뢰하기</Text>
          </Button>
        </RowBox>
      </Box>
    </S.Header>
  );
}
